module.exports = __webpack_public_path__ + "static/DS_babyshower-a41c7c70b890cd866c4f6af45a19dcf8.jpeg";